import { applicationActions } from "../reducer";
import { NoticeType } from "../../types";

import { Data } from '../reducer/setNotice';

export const setNotice = (
  data: Data,
  type: NoticeType
) => applicationActions.setNotice({ data, type });
